"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { CircleCheck, MapPin, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Get1020QualifiedRoofingLeadsEveryWeek() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="238217" id="die-zukunft-des-spendens" className="relative bg-background py-20 lg:py-32 overflow-hidden" ref={sectionRef}>
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:24px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none"></div>
      
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none flex items-center justify-center overflow-hidden">
        <div className="text-[40rem] font-black text-foreground select-none">+</div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className={`lg:col-span-12 flex flex-col justify-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 text-primary-foreground text-sm font-medium mb-6 w-fit border border-primary/20">
              <MapPin className="size-4 text-primary" />
              <span className="text-blue-600">Schweizer Präzision & Sicherheit</span>
            </div>
            
            <h1 className="font-default font-bold text-5xl sm:text-6xl lg:text-7xl leading-[1.1] tracking-tighter text-black">
              Die Entwicklung der Schweizer Kryptophilanthropie
            </h1>
            
            <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed font-default">
              Revolutionieren Sie Ihre Wirkung mit Crypto-Donations. Erleben Sie blitzschnelle Transaktionen und minimale Gebühren im Vergleich zum traditionellen Bankwesen.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-base font-bold shadow-lg shadow-primary/20 group">
                <Link to="/DonorsPage">
                  Jetzt Spenden
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1 animate-pulse" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base font-bold bg-background/50 backdrop-blur-sm border-border/50">
                <Link to="/FoundationsPage">
                  Für Stiftungen
                </Link>
              </Button>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 pt-8 border-t border-border/20">
              {["Echtzeit-Transparenz", "Niedrige Gebühren", "Globale Reichweite"].map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                  <CircleCheck className="size-5 text-chart-2 shrink-0" />
                  <span className="text-sm font-medium text-foreground font-default">{benefit}</span>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}